import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
// basic
import homeReducer from './slices/home';
import courseReducer from './slices/course';
import cmsReducer from './slices/cms';
import campusReducer from './slices/campus';
import blogReducer from './slices/blog';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

/* const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
}; */

const rootReducer = combineReducers({
  home: homeReducer,
  course: courseReducer,
  cms:cmsReducer,
  campus:campusReducer,
  blog: blogReducer,
});

export { rootPersistConfig, rootReducer };
